import React from 'react';
import styled, { css } from 'styled-components';

import TX from '@Components/Common/Text';

import MainBackgroundImage from '@Assets/Images/bg_main.jpg';
import LogoImage from '@Assets/Images/logo_workshop.png';

const MobileHome = () => {
  return (
    <MobileHomeContainer>
      <LogoContainer>
        <Logo />
      </LogoContainer>

      <NoticeText>
        현재 PC로만 접속 가능합니다.
        <br />
        PC에서 이용해 주세요.
      </NoticeText>
    </MobileHomeContainer>
  );
};

const FlexAlignCenterCSS = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const BackgroundImageCSS = css`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const MobileHomeContainer = styled.div`
  ${FlexAlignCenterCSS}
  ${BackgroundImageCSS}

  height: 100vh;
  background-color: #323232;
  background-image: radial-gradient(50% 50% at 50% 50%, rgba(0, 0, 0, 0) 22.99%, rgba(0, 0, 0, 0.2) 100%),
    linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url(${MainBackgroundImage});

  @supports (-webkit-touch-callout: none) {
    height: -webkit-fill-available;
  }
`;

const LogoContainer = styled.div``;

const Logo = styled.img.attrs({
  src: LogoImage,
  alt: '서울 2033 창작마당',
})`
  width: 160px;
  height: 80px;
  -webkit-user-drag: none;

  margin-bottom: 32px;
`;

const NoticeText = styled(TX.BodyM)`
  text-align: center;
  line-height: 24px;

  color: ${({ theme }) => theme.colors.white};
`;

export default MobileHome;
